import { createFileRoute } from '@tanstack/react-router';

// NOT-228: this index used to `redirect` to the first estimate's detail to fill
// the old master-detail right pane — but once the detail became a full-page view
// (which hides the list), that redirect made `/dashboard/estimates` jump straight
// to an estimate with no list, so the browser/breadcrumb back could never return
// to the list. The parent layout (estimates.tsx) now renders the Table on desktop
// and the list on mobile, so this index renders nothing (mirrors jobs/index.tsx).
export const Route = createFileRoute('/_dashboard/dashboard/estimates/')({
  component: () => null,
});
